var path = 'app/core/components/modal/backdrop.html';
var html = "<div\n  class=\"modal-backdrop fade {{ backdropClass }}\"\n  ng-class=\"{in: animate}\"\n  ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n></div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;